// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__3ddOh","showModal":"Modal_showModal__3v2ey","outer":"Modal_outer__1BBJ1","close":"Modal_close__2s-zx"};